import React, { FC } from 'react';
import { ThemeProvider } from 'styled-components';
import theme from './theme';
import { ThemeProps } from './types';

export const Theme: FC<ThemeProps> = ({ children, brandTheme }) => (
  <ThemeProvider theme={{ ...theme, brandTheme }}>{children}</ThemeProvider>
);
